// scheduling/components/NicheGapFlag.jsx
// Advisory chip shown on staff-suggestion surfaces when a NON-individual client has
// no real niche (industry is 'Unknown'/'Other'/'No Selection' or unset). Niche
// experience can't be scored then, so fit scores read low — this tells the user why
// and how to fix it. Individual clients are scored on service-line experience and are
// never flagged (the backend sets job.nicheMissing accordingly). Renders nothing
// unless `missing` is true. Advisory-orange palette mirrors .idd-py-chip--info.

const TIP = "This client's industry ('Unknown', 'Other', 'No Selection', or unset) isn't a "
  + "niche, so niche experience isn't scored and fit scores may read low. Set the client's "
  + "industry in Practice Engine to fix it. (Individual clients are scored on service-line "
  + "experience instead and aren't flagged.)";

export default function NicheGapFlag({ missing, style }) {
  if (!missing) return null;
  return (
    <span
      className="sched-sug-niche-gap"
      title={TIP}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: '#FFEDD5', color: '#9A3412', border: '1px solid #FB923C',
        fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4,
        whiteSpace: 'nowrap', cursor: 'help', ...style,
      }}
    >
      ⚠ No niche set
    </span>
  );
}
